export default function OBTechnical() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-14">
          Platform Düzeyinde Entegrasyon Verimliliği Nasıl Sağlar?
        </h2>

        {/* Row 1 */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Düzenlenmiş özel bulutlar, depolama, hesaplama ve ağ ürünlerini otomasyon API'leri aracılığıyla koordine eder.
              Her altyapı katmanı kendi kontrol düzlemini, meta veri yapılarını ve kaynak tahsis mekanizmalarını korur.
              Bir VM depolama talep ettiğinde, istek hiper yöneticiden depolama API'sine, ardından dizi denetleyicisine kadar
              birden fazla yönetim katmanını geçer; her katman ayrı önbellekleme, tekilleştirme ve optimizasyon mantığı işletir.
              Bu mimari ayrışma, altyapı ekibinin zamanının{' '}
              <span className="font-bold text-[#e8600a]">%40-60'ını</span> sürüm uyumluluğunu yönetmeye,
              çapraz ürün arızalarını gidermeye ve satıcılar arasında yükseltme pencerelerini koordine etmeye harcatır.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden border border-gray-100">
            <img
              src="https://www.verge.io/wp-content/uploads/2026/02/Orchestrated-Infrastructure.webp"
              alt="Düzenlenmiş Altyapı Mimarisi"
              className="w-full object-top"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="rounded-xl overflow-hidden border border-gray-100 md:order-1">
            <img
              src="https://www.verge.io/wp-content/uploads/2026/02/vergeos-efficiency-transparent.png"
              alt="VergeOS Verimlilik Mimarisi"
              className="w-full object-top"
            />
          </div>
          <div className="md:order-2">
            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              <strong className="text-[#1e293b]">Platform düzeyinde entegrasyon kaynak yolunu değiştirir.</strong>{' '}
              VergeOS, depolamayı, ağı ve veri hizmetlerini tüm altyapı kaynaklarını eş zamanlı gören tek bir kontrol
              düzleminde uygular. Bir VM depolama talep ettiğinde, platform API çeviri katmanları olmadan birleşik bir
              kaynak havuzundan tahsis yapar.
            </p>
            <div className="grid grid-cols-1 gap-3">
              <div className="flex items-start gap-3 bg-[#f8fafc] rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0">
                  <i className="ri-database-2-line text-base"></i>
                </span>
                <div>
                  <p className="text-xs font-semibold text-[#1e293b] mb-1">3-4 Kat Daha Etkili Önbellekleme</p>
                  <p className="text-xs text-gray-500">VM'leri çalıştıran DRAM, depolama I/O'sunu da önbellekler — ayrı yapılandırmalara kıyasla çok daha verimli.</p>
                </div>
              </div>
              <div className="flex items-start gap-3 bg-[#f8fafc] rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0">
                  <i className="ri-server-line text-base"></i>
                </span>
                <div>
                  <p className="text-xs font-semibold text-[#1e293b] mb-1">%30-40 Sunucu Azaltımı</p>
                  <p className="text-xs text-gray-500">Platform, ayrı ürünleri koordine etmede bulunan gereksiz önbellekleme, meta veri yükü ve kaynak parçalanmasını ortadan kaldırır.</p>
                </div>
              </div>
              <div className="flex items-start gap-3 bg-[#f8fafc] rounded-lg p-4">
                <span className="w-8 h-8 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0">
                  <i className="ri-settings-3-line text-base"></i>
                </span>
                <div>
                  <p className="text-xs font-semibold text-[#1e293b] mb-1">Altyapı Genelinde Tekilleştirme</p>
                  <p className="text-xs text-gray-500">Sıkıştırma ve ince sağlama, ürün sınırları içinde değil tüm altyapı genelinde çalışır.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
